import { render, staticRenderFns } from "./b-icon-add.vue?vue&type=template&id=74e347e9"
import script from "./b-icon-add.vue?vue&type=script&lang=js"
export * from "./b-icon-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports